module.exports = __webpack_public_path__ + "static/media/Straznice.781323ea.md";